import { render } from "./SplitTimeline.vue?vue&type=template&id=c94ec112&scoped=true&ts=true"
import script from "./SplitTimeline.vue?vue&type=script&lang=ts"
export * from "./SplitTimeline.vue?vue&type=script&lang=ts"

import "./SplitTimeline.vue?vue&type=style&index=0&id=c94ec112&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c94ec112"]])

export default __exports__